export const countries = [
  { id: 1, name: 'Lietuva' },
  { id: 2, name: 'Užsienis' },
];
